/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { isEmpty, isNil } from "ramda";

import { MapContainer, TileLayer, Marker, Polyline, useMap, Polygon, Circle, Pane, Popup } from "react-leaflet";
import { IS_ONLINE, MAP_TYPES } from "../../../../../config/configmap";
import { Icon } from "leaflet";
import L from "leaflet";

import { PlayBar } from "./styled";
import { Box, Button, LinearProgress } from "@mui/material";
import palette, { polylineColors } from "../../../../../config/colorPalette";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import ReplayIcon from "@mui/icons-material/Replay";
import { getShipTrackingHistorial } from "../../../../api";

const MapInclinometer = ({ assetData, substructure, intl }) => {
  const mapType = "regular";
  const [inclinometerPosition, setinclinometerPosition] = useState(substructure.polyline);

  const customIcon = new Icon({
    iconUrl: require(`../../../../../images/Uptech-marker-icon-inclinometer.png`),
    iconSize: [60, 60],
    iconAnchor: [27, 60],
  });

  function ChangeView() {
    const mapView = useMap();
    useEffect(() => {
      mapView.dragging.enable();
      mapView.scrollWheelZoom.enable();
      mapView.doubleClickZoom.enable();
      mapView.boxZoom.enable();
      mapView.keyboard.enable();

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mapView]);

    if (!isEmpty(inclinometerPosition)) {
      mapView.setMaxBounds(null);
      mapView.setView(inclinometerPosition, 15, { reset: false });
    }

    return null;
  }

  return (
    <MapContainer
      id="map-for-inclinometer"
      style={{ width: "30rem", height: "30rem" }}
      center={inclinometerPosition}
      zoom={11}
    >
      <TileLayer
        attribution={window.RUNTIME_CONFIG.IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
        url={window.RUNTIME_CONFIG.MAP_TYPES.find((type) => type.value === mapType).tileLayer}
        maxZoom={18}
        subdomains={["mt0", "mt1", "mt2", "mt3"]}
      />
      <Pane name="polygonsPane" style={{ zIndex: 400 }} />
      <Pane name="linesPane" style={{ zIndex: 500 }} />
      <ChangeView />
      {!isNil(substructure) && !isEmpty(inclinometerPosition) && (
        <Marker key={substructure.name} position={inclinometerPosition} icon={customIcon}></Marker>
      )}
    </MapContainer>
  );
};

export default MapInclinometer;
